'use strict';

class ThumbnailTray {
  constructor(data, $el) {
    this.isVertical = data.vertical;
    this.sizeProp = this.isVertical ? "height" : "width";
    this.positionProp = this.isVertical ? "top" : "left";

    this.carouselSize = $el[this.sizeProp]();
    this.$thumbControlForward = $el.find('.thumbnails-button.forward');
    this.$thumbControlBack = $el.find('.thumbnails-button.back');
    this.$thumbnailWrapper = $el.find('.thumbnail-wrapper');
    this.$thumbnails = this.$thumbnailWrapper.find('li');
    this.$thumbnailTray = this.$thumbnailWrapper.find("#thumbnail-tray");
  }

  fixHeight(height) {
    if (this.isVertical) this.$thumbnailWrapper.css({height});
  }

  onLoad(newImageId) {
    this.updateSelectedThumbnail(newImageId);
    let $thumbnailImgs = this.$thumbnails.find('img');

    this.thumbnailDimension = this.isVertical ? this.$thumbnailTray.find("li").first().outerHeight(true) : this.$thumbnailTray.find("li").first().outerWidth(true);

    let thumbnailSize = $thumbnailImgs.length * this.thumbnailDimension;
    this.$thumbnailTray.css(this.sizeProp, `${thumbnailSize}px`);

    if (this.carouselSize < thumbnailSize) {
      this.$thumbnailTray.css("margin", "0px");
      this.$thumbnailWrapper.find('.thumbnails-controls').show();
      const cssProps = {}
      cssProps[`padding-${this.resolveDimensionName(false)}`] = '20px';
      cssProps[`padding-${this.resolveDimensionName(true)}`] = '20px';
      this.$thumbnailWrapper.css(cssProps);
      this.calculateThumbnailPages();
    } else {
      this.$thumbnailWrapper.find('.thumbnails-controls').remove();
    }

    this.$thumbControlForward.click(() => this.pageThumbnailsForward());
    this.$thumbControlBack.click(() => this.pageThumbnailsBack());

    $thumbnailImgs.lazyload({skip_invisible: false});

    $(window).resize(() => this.calculateThumbnailPages());
  }

  getChangeEventType() {
    return this.isVertical ? 'mouseenter' : 'click';
  }

  calculateThumbnailPages() {
    let thumbnailSize = parseInt(this.$thumbnailTray.css(this.sizeProp));
    let carouselSize = (this.isVertical ? this.$thumbnailWrapper.height() : this.$thumbnailWrapper.width());
    carouselSize -= carouselSize % this.thumbnailDimension;
    this.thumbnailTrayMultiples = carouselSize;
    this.thumbnailTraySize = (this.isVertical ? this.$thumbnailTray.innerHeight() : this.$thumbnailTray.innerWidth());
    this.thumbnailFullPages = Math.floor(thumbnailSize / carouselSize);
    this.thumbnailHasPartial = (this.thumbnailFullPages != (thumbnailSize / carouselSize));
  }

  getCurrentThumbnailBounds() {
    let lowerbound = Math.abs(parseInt(this.$thumbnailTray.css(this.positionProp)));
    let higherbound = lowerbound + (this.isVertical ? this.$thumbnailWrapper.height() : this.$thumbnailWrapper.width());
    return {lowerbound, higherbound};
  }

  getThumbnailPosition(thumbnail) {
    let position = thumbnail.position();
    if(this.isVertical) {
      position.left = position.top;
      position.right = position.left + this.thumbnailDimension - 10;
    }
    else {
      position.right = position.left + this.thumbnailDimension;
    }
    return position;
  }

  updateSelectedThumbnail(newImageId) {
    this.$thumbnails.removeClass('selected')
    let newThumbnail = this.$thumbnailWrapper.find(`li[data-id='${newImageId}']`);
    newThumbnail.addClass('selected');
  }

  adjustThumbnail(newImageId) {
    this.updateSelectedThumbnail(newImageId);

    let $newThumbnail = this.$thumbnailWrapper.find(`li[data-id='${newImageId}']`);

    if (this.thumbnailHasPartial) {
      const { lowerbound, higherbound } = this.getCurrentThumbnailBounds();
      const position = this.getThumbnailPosition($newThumbnail);

      let newPosition;

      if (position.left < higherbound && position.right > higherbound) {
        newPosition = this.$thumbnailWrapper[this.sizeProp]() - ($newThumbnail.position()[this.positionProp] + this.thumbnailDimension) + 10;
      }
      else if (position.left < lowerbound && position.right > lowerbound) {
        newPosition = -$newThumbnail.position()[this.positionProp];
      }

      if (newPosition !== undefined) {
        this.$thumbnailTray.css(this.positionProp, `${newPosition}px`);
      }
    }
  }

  jumpToThumbnail(newImageId) {
    this.updateSelectedThumbnail(newImageId);
    let newThumbnail = this.$thumbnailWrapper.find(`li[data-id="${newImageId}"]`);

    const { lowerbound, higherbound } = this.getCurrentThumbnailBounds();
    const position = this.getThumbnailPosition(newThumbnail);

    if (position.left < lowerbound || position.right > higherbound) {
      let thumbnailEdge = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
      let newPosition = Math.max(-newThumbnail.position()[this.positionProp], thumbnailEdge);

      this.$thumbnailTray.css(this.positionProp, `${newPosition}px`);
    }
  }

  pageThumbnailsForward() {
    let position, lowerbound, upperbound, currentPosition;
    currentPosition = parseInt(this.$thumbnailTray.css(this.positionProp));
    lowerbound = 0;
    upperbound = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
    if (currentPosition === upperbound) {
      position = lowerbound;
    }
    else {
      position = Math.max(upperbound, currentPosition - this.thumbnailTrayMultiples);
    }
    this.$thumbnailTray.css(this.positionProp, `${position}px`);
  }

  pageThumbnailsBack() {
    let position, lowerbound, upperbound, currentPosition;
    currentPosition = parseInt(this.$thumbnailTray.css(this.positionProp));
    lowerbound = 0;
    upperbound = this.$thumbnailWrapper[this.sizeProp]() - this.$thumbnailTray[this.sizeProp]() + 10;
    if (currentPosition === lowerbound) {
      position = upperbound;
    }
    else {
      position = Math.min(lowerbound, currentPosition + this.thumbnailTrayMultiples);
    }
    this.$thumbnailTray.css(this.positionProp, `${position}px`);
  }

  resolveDimensionName(direction) {
    if(direction) {
      if(this.isVertical) return "bottom";
      return "right";
    }
    if(this.isVertical) return "top";
    return "left";
  }
}

module.exports = ThumbnailTray;



// WEBPACK FOOTER //
// ./modules/carousel/frontend/ThumbnailTray.js